import styles from './DragAndDropItem.module.scss';
var DragAndDropHelpers;
(function (DragAndDropHelpers) {
    const memo = {
        options: null,
        rowElements: {
            hoverElement: null,
            boundingRect: null,
            data: null,
        },
    };
    DragAndDropHelpers.getOptions = (dragElement, hoverElement, monitor) => {
        var _a, _b, _c, _d;
        const clientOffset = monitor.getClientOffset();
        const isUpdated = ((_a = memo.options) === null || _a === void 0 ? void 0 : _a.hoverElement) !== hoverElement ||
            ((_b = memo.options) === null || _b === void 0 ? void 0 : _b.dragElement) !== dragElement ||
            clientOffset.y !== ((_c = memo.options) === null || _c === void 0 ? void 0 : _c.clientOffset.y) ||
            clientOffset.x !== ((_d = memo.options) === null || _d === void 0 ? void 0 : _d.clientOffset.x);
        if (!isUpdated && memo.options) {
            return Object.assign(Object.assign({}, memo.options.data), { isUpdated: isUpdated });
        }
        const hoverBoundingRect = hoverElement.getBoundingClientRect();
        const dragBoundingRect = dragElement.getBoundingClientRect();
        const mousePosition = {
            x: clientOffset.x - hoverBoundingRect.left,
            y: clientOffset.y - hoverBoundingRect.top,
        };
        memo.options = {
            clientOffset: clientOffset,
            dragElement: dragElement,
            hoverElement: hoverElement,
            data: {
                mouse: mousePosition,
                dragElement: {
                    boundingRect: dragBoundingRect,
                },
                hoverElement: {
                    middleX: (hoverBoundingRect.right - hoverBoundingRect.left) / 2,
                    middleY: (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2,
                    boundingRect: hoverBoundingRect,
                },
                isUpdated: isUpdated,
            },
        };
        return memo.options.data;
    };
    DragAndDropHelpers.setElementsMovements = (elements, startIndex = 0) => {
        for (let i = 0; i < elements.length; i++) {
            if (i >= startIndex) {
                elements[i].element.classList.add(styles.dropFocusMove);
            }
            else {
                elements[i].element.classList.remove(styles.dropFocusMove);
            }
        }
    };
    DragAndDropHelpers.removeElementsMovements = (elements) => {
        elements.forEach((item) => {
            item.element.classList.remove(styles.dropFocusMove);
        });
    };
    DragAndDropHelpers.setLineAfterElement = (element) => {
        element.classList.remove(styles.dropFocusBefore);
        element.classList.add(styles.dropFocusAfter);
    };
    DragAndDropHelpers.setLineBeforeElement = (element) => {
        element.classList.remove(styles.dropFocusAfter);
        element.classList.add(styles.dropFocusBefore);
    };
    DragAndDropHelpers.removeElementFocusLine = (element) => {
        element.classList.remove(styles.dropFocusAfter, styles.dropFocusBefore, styles.dropFocusMove);
    };
    DragAndDropHelpers.setElementFocusLine = (element, options) => {
        if (options.hoverElement.middleX < options.mouse.x) {
            DragAndDropHelpers.setLineAfterElement(element);
        }
        else {
            DragAndDropHelpers.setLineBeforeElement(element);
        }
    };
    DragAndDropHelpers.getSiblingElementsInRow = (element, boundingRect) => {
        if (memo.rowElements &&
            memo.rowElements.hoverElement === element &&
            boundingRect.x === memo.rowElements.boundingRect.x &&
            boundingRect.y === memo.rowElements.boundingRect.y) {
            return memo.rowElements.data;
        }
        const rowElements = [{ element: element, boundingRect: boundingRect }];
        let prevElement = element.previousElementSibling;
        let nextElement = element.nextElementSibling;
        while (nextElement || prevElement) {
            if (prevElement) {
                const prevElementBoundingRect = prevElement.getBoundingClientRect();
                if (prevElementBoundingRect.top === boundingRect.top) {
                    rowElements.unshift({ element: prevElement, boundingRect: prevElementBoundingRect });
                    prevElement = prevElement.previousElementSibling;
                }
                else {
                    prevElement = null;
                }
            }
            if (nextElement) {
                const nextElementBoundingRect = nextElement.getBoundingClientRect();
                if (nextElementBoundingRect.top === boundingRect.top) {
                    rowElements.push({ element: nextElement, boundingRect: nextElementBoundingRect });
                    nextElement = nextElement.nextElementSibling;
                }
                else {
                    nextElement = null;
                }
            }
        }
        memo.rowElements.hoverElement = element;
        memo.rowElements.data = rowElements;
        memo.rowElements.boundingRect = boundingRect;
        return rowElements;
    };
    DragAndDropHelpers.clear = () => {
        memo.options = null;
        memo.rowElements.hoverElement = null;
        memo.rowElements.data = null;
        memo.rowElements.boundingRect = null;
    };
})(DragAndDropHelpers || (DragAndDropHelpers = {}));
export default DragAndDropHelpers;
